import { render, staticRenderFns } from "./commonBaseInfo.vue?vue&type=template&id=85412b7c&scoped=true"
import script from "./commonBaseInfo.vue?vue&type=script&lang=js"
export * from "./commonBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./commonBaseInfo.vue?vue&type=style&index=0&id=85412b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85412b7c",
  null
  
)

export default component.exports